<template>
  <div class="message-wrp">
    <div class="divider"></div>
    <div class="message">
      <p class="title">{{message.title}}</p>
      <p class="date">{{message.createTime.slice(0, 10)}}</p>
      <p class="content" v-html="content">
        {{content}}
      </p>
    </div>
  </div>
</template>

<script>
import { messageRequest } from '@services'
import { Notify } from 'vant'

export default {
  data () {
    return {
      message: {
        title: '',
        createTime: '',
        content: ''
      },
      content: ''
    }
  },
  mounted () {
    this.getMessageDetail(this.$route.query.id)
    this.readMessage(this.$route.query.id)
  },
  computed: {
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    async getMessageDetail (id) {
      const data = await messageRequest.message.detail({ id })
      if (data.success) {
        this.message = data.result
        this.content = data.result.content
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    readMessage (id) {
      messageRequest.message.read({}, { id })
    }
  }
}
</script>

<style lang="less" scoped>
  .message-wrp {
    width: 100%;
    position: relative;
    min-height: calc(100% - 10px);
    background: white;
    .message {
      width: 100%;
      margin: 10px auto;
      padding: 10px 25px;
      box-sizing: border-box;
      .title {
        font-size:36px;
        font-weight:bold;
        color:rgba(0,0,0,1);
        line-height:70px;
        text-align: center;
      }
      .date {
        height:19px;
        text-align: center;
        font-size:24px;
        color:rgba(153,153,153,1);
      }
      .content {
        font-size:26px;
        color:rgba(51,51,51,1);
        line-height:50px;
        overflow-wrap: break-word;
        margin-top: 60px;
        font-size:26px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:50px;
      }
    }
  }
</style>
